import type * as electron_typeonly from 'electron';
import type { ElectronBridge } from './electron-bridge-types';

declare function __non_webpack_require__(p: string): any;
const nodeRequire =
    typeof __non_webpack_require__ !== 'undefined' ? __non_webpack_require__ : typeof require !== 'undefined' ? require : undefined;

let electron: typeof electron_typeonly;
if (nodeRequire) {
    try {
        electron = nodeRequire('electron');
    } catch {}
}

let params: URLSearchParams | undefined;
try {
    params = new URLSearchParams(window.location.search);
} catch (err) {
    if (!(err instanceof ReferenceError)) {
        throw err;
    }
}

const invoker =
    (channel: string) =>
    (...args: any[]) =>
        electron.ipcRenderer.invoke(channel, ...args);

// Full context isolation would require setting `electronBridge` on `window` in preload script,
// and then fetching it here
const statics = JSON.parse(params?.get('electronStatic') || 'null');

const mirrorContextIdParam = params?.get('mirrorContextId');
export const mirrorContextIdFromUrl: number | undefined =
    mirrorContextIdParam !== null && mirrorContextIdParam !== undefined ? parseInt(mirrorContextIdParam, 10) : undefined;

export const electronBridge: ElectronBridge | undefined = statics && {
    app: {
        quit: invoker('electron-app-quit'),
    },
    dialog: {
        showMessageBox: invoker('electron-dialog-showMessageBox'),
        showOpenDialog: invoker('electron-dialog-showOpenDialog'),
        showSaveDialog: invoker('electron-dialog-showSaveDialog'),
    },
    menu: {
        popup: {
            build: invoker('electron-menu-popup-build'),
            show: invoker('electron-menu-popup-show'),
            close: invoker('electron-menu-popup-close'),
        },
    },
    window: {
        close: invoker('electron-window-close'),
        setTitle: invoker('electron-window-setTitle'),
        onMirrorStatus: (handler) => electron.ipcRenderer.on('mirror-status', (_e, hasMirrors) => handler(hasMirrors)),
    },
    clipboard: {
        readText: invoker('electron-clipboard-readText'),
        writeText: invoker('electron-clipboard-writeText'),
    },
    mirrorContext: {
        get: invoker('get-mirror-context'),
    },
    xcpProxy: {
        invoke: invoker('xcp-proxy-invoke'),
        onState: (handler) => electron.ipcRenderer.on('xcp-proxy-state', (_e, ev) => handler(ev)),
    },
    xcpOwner: {
        register: (deviceId) => electron.ipcRenderer.send('xcp-proxy-register', { deviceId }),
        unregister: (deviceId) => electron.ipcRenderer.send('xcp-proxy-unregister', { deviceId }),
        onExecute: (handler) => electron.ipcRenderer.on('xcp-proxy-execute', (_e, req) => handler(req)),
        sendResult: (result) => electron.ipcRenderer.send('xcp-proxy-result', result),
    },
    paramSync: {
        send: (updates) => electron.ipcRenderer.send('param-sync-send', updates),
        requestAll: () => electron.ipcRenderer.send('param-sync-request-all'),
        onUpdate: (handler) => electron.ipcRenderer.on('param-sync-update', (_e, updates) => handler(updates)),
        onRequestAll: (handler) => electron.ipcRenderer.on('param-sync-request-all', () => handler()),
    },
    statics,
};
